import { Outlet } from '@tanstack/react-router';

import { BranchEnvIndicator } from '@crossnokaye/ux-smarts';

import { AppConfigs, clearBranch } from '@/config';

export function BaseLayout(): React.ReactElement {
  return (
    <div className={'flex flex-col h-screen relative'}>
      <BranchEnvIndicator
        onClearBranch={clearBranch}
        branchConfigs={{
          deployedBranch: AppConfigs.isLocal ? 'local' : 'main',
          uiBranch: AppConfigs.uiBranch,
        }}
        deploymentConfigs={{
          environment: AppConfigs.atlasEnv,
          isProduction: AppConfigs.isProduction,
          isDevelopment: AppConfigs.isDevelopment,
        }}
      >
        <main className={'flex flex-col h-full relative'} id={'base-container'}>
          <Outlet />
        </main>
      </BranchEnvIndicator>
    </div>
  );
}
